/* eslint-disable complexity */
import { useFormContext } from '@/components/form/formHooks';
import { Button, ButtonProps } from '@/components/ui/button';
import {
  faSpinnerThird,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

type SubmitButtonProps = {
  buttonText: string;

  leadingIcon?: IconDefinition;
} & ButtonProps;

export function FormSubmitButton({
  buttonText,
  variant = 'default',
  size,
  leadingIcon,
  disabled,
  ...rest
}: SubmitButtonProps) {
  const form = useFormContext();
  const { t } = useTranslation();
  return (
    <form.Subscribe
      selector={(state) => [
        state.isSubmitting,
        state.canSubmit,
        state.isValid,
        state.isTouched,
      ]}>
      {([isSubmitting, canSubmit, isValid, isTouched]) => {
        const buttonContent = isSubmitting ? (
          <>
            <FontAwesomeIcon icon={faSpinnerThird} spin />
            {t('actions.loading')}
          </>
        ) : (
          <>
            {leadingIcon && (
              <FontAwesomeIcon icon={leadingIcon} className="mr-2" />
            )}
            {buttonText}
          </>
        );

        return (
          <Button
            variant={variant}
            type="submit"
            size={size}
            disabled={
              isSubmitting || !canSubmit || !isValid || !isTouched || disabled
            }
            className="gap-2"
            {...rest}>
            {buttonContent}
          </Button>
        );
      }}
    </form.Subscribe>
  );
}
